import { renderPageShell } from '../lib/page-shell';
import { forgotPassword } from '../lib/session';
import type { RouteHandler } from '../lib/router';

export const renderForgotPassword: RouteHandler = (container, navigate) => {
  const body = renderPageShell(container, navigate, 'account', {
    title: 'FORGOT PASSWORD',
    subtitle: "Enter the email on your account and we'll send a reset link.",
    body: `
      <form class="choice-card" id="forgot-form" aria-labelledby="forgot-heading">
        <strong id="forgot-heading">Reset your password</strong>
        <input class="join-input" name="email" type="email" placeholder="Email" aria-label="Email" autocomplete="email" required />
        <button class="button button--primary" type="submit">Send reset link</button>
        <p class="form-error" data-role="status" aria-live="polite"></p>
      </form>
    `,
  });

  const form = body.querySelector<HTMLFormElement>('#forgot-form')!;
  const status = form.querySelector<HTMLParagraphElement>('[data-role="status"]')!;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const email = String(new FormData(form).get('email'));
    const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]')!;
    submitButton.disabled = true;
    try {
      await forgotPassword(email);
      // Deliberately the same message whether or not the email matched an
      // account — the API itself never reveals that (see auth-routes.ts's
      // handleForgotPassword), so the UI shouldn't either.
      form.innerHTML = `<p>If that email is registered, a reset link is on its way. It expires in an hour.</p>`;
    } catch (error) {
      status.textContent = error instanceof Error ? error.message : 'Could not send reset link.';
      submitButton.disabled = false;
    }
  });
};
